"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRowId = exports.areIdsEquals = exports.children2ColumnOptions = exports.getSelectedRowIds = void 0;
var react_1 = require("react");
var _1 = require(".");
var utils_1 = require("../utils");
// returns { 1: true, 2: true }
function getSelectedRowIds(ids) {
    var result = {};
    ids.forEach(function (id) {
        result[id] = true;
    });
    return result;
}
exports.getSelectedRowIds = getSelectedRowIds;
// 将 children（<Column /> 组）转为 InternalColumnOptions 列表
function children2ColumnOptions(children) {
    var columns = [];
    react_1.Children.toArray(children).filter(react_1.isValidElement).forEach(function (_a) {
        var type = _a.type, props = _a.props;
        if (type !== _1.TableColumn) {
            if (utils_1.isDev) {
                // eslint-disable-next-line no-console
                console.warn('Unknown element type, expected `<TableColumn />`, while got', type);
            }
            return;
        }
        columns.push(props);
    });
    return columns;
}
exports.children2ColumnOptions = children2ColumnOptions;
function areIdsEquals(idsA, idsB) {
    if (idsA === idsB)
        return true;
    var idsAKeys = Object.keys(idsA).filter(function (id) { return idsA[id]; });
    var idsBKeys = Object.keys(idsB).filter(function (id) { return idsB[id]; });
    // 过滤掉值为 false 的 id 再对比长度
    if (idsAKeys.length !== idsBKeys.length)
        return false;
    for (var _i = 0, idsBKeys_1 = idsBKeys; _i < idsBKeys_1.length; _i++) {
        var item = idsBKeys_1[_i];
        if (idsA[item] === undefined) {
            return false;
        }
    }
    return true;
}
exports.areIdsEquals = areIdsEquals;
function getRowId(record, recordIdAccessor) {
    if (recordIdAccessor == null) {
        return null;
    }
    var id = record[recordIdAccessor];
    if (typeof id !== 'string') {
        throw Error('Unsupported record id type.');
    }
    return id;
}
exports.getRowId = getRowId;
//# sourceMappingURL=utils.js.map